import React from 'react';

const INTENT_LABELS = {
	ignore: 'Ignored',
	resolve_bare: 'RESOLVE',
	resolve_index: 'RESOLVE N',
	resolve_all: 'RESOLVE ALL',
	confirm_assumed: 'Confirm',
	pick_alternative: 'Pick Alternative',
	other: 'Other',
};

const SmsResponseDetailsModal = ({ item, onClose }) => {
	const formatDate = (dateString) => {
		if (!dateString) return '-';
		return dateString;
	};

	return (
		<>
			<div
				className="modal-backdrop fade show"
				onClick={onClose}
				style={{ zIndex: 1040 }}
			/>
			<div
				className="modal fade show d-block"
				tabIndex="-1"
				style={{ zIndex: 1050 }}
			>
				<div className="modal-dialog modal-lg modal-dialog-scrollable">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">
								<i className="bi bi-chat-dots me-2" />
								SMS Reply Details
							</h5>
							<button type="button" className="btn-close" onClick={onClose} />
						</div>
						<div className="modal-body">
							<div className="mb-4">
								<h6 className="border-bottom pb-2 mb-3">Inbound Message</h6>
								<div className="row g-3">
									<div className="col-md-6">
										<label className="text-muted small">When</label>
										<div>{formatDate(item.created_at)}</div>
									</div>
									<div className="col-md-6">
										<label className="text-muted small">Intent</label>
										<div>
											<span className="badge bg-info">
												{INTENT_LABELS[item.parsed_intent] ||
													item.parsed_intent ||
													'—'}
											</span>
										</div>
									</div>
									<div className="col-md-6">
										<label className="text-muted small">From</label>
										<div>
											<code>{item.from_phone || '—'}</code>
										</div>
									</div>
									<div className="col-md-6">
										<label className="text-muted small">To</label>
										<div>
											<code>{item.to_phone || '—'}</code>
										</div>
									</div>
									<div className="col-md-12">
										<label className="text-muted small">Body</label>
										<div className="p-2 bg-light rounded">
											{item.body || (
												<span className="text-muted">Empty</span>
											)}
										</div>
									</div>
									<div className="col-md-12">
										<label className="text-muted small">App Reply</label>
										<div className="p-2 bg-light rounded">
											{item.reply_body || (
												<span className="text-muted">None (silent)</span>
											)}
										</div>
									</div>
									<div className="col-md-6">
										<label className="text-muted small">Team notified</label>
										<div>
											{item.team_notified ? (
												<span className="badge bg-success">yes</span>
											) : (
												<span className="badge bg-secondary">no</span>
											)}
										</div>
									</div>
									<div className="col-md-6">
										<label className="text-muted small">Signature</label>
										<div>
											{item.signature_valid ? (
												<span className="badge bg-success">valid</span>
											) : (
												<span className="badge bg-danger">invalid</span>
											)}
										</div>
									</div>
								</div>
							</div>

							<div className="mb-4">
								<h6 className="border-bottom pb-2 mb-3">Subscriber</h6>
								{item.user ? (
									<div className="row g-3">
										<div className="col-md-6">
											<label className="text-muted small">Name</label>
											<div>{item.user.name}</div>
										</div>
										<div className="col-md-6">
											<label className="text-muted small">Email</label>
											<div>{item.user.email}</div>
										</div>
										<div className="col-md-6">
											<label className="text-muted small">Phone</label>
											<div>{item.user.phone || '—'}</div>
										</div>
										<div className="col-md-6">
											<label className="text-muted small">User ID</label>
											<div>#{item.user.id}</div>
										</div>
									</div>
								) : (
									<div className="text-muted">
										No matching user for this phone number.
									</div>
								)}
							</div>

							{item.pending && (
								<div className="mb-4">
									<h6 className="border-bottom pb-2 mb-3">
										Pending Confirm State
									</h6>
									<div className="row g-3">
										<div className="col-md-4">
											<label className="text-muted small">Status</label>
											<div>
												<span className="badge bg-warning">
													{item.pending.status}
												</span>
											</div>
										</div>
										<div className="col-md-4">
											<label className="text-muted small">Keyword</label>
											<div>{item.pending.keyword_received || '—'}</div>
										</div>
										<div className="col-md-4">
											<label className="text-muted small">Expires</label>
											<div>{formatDate(item.pending.expires_at)}</div>
										</div>
										{item.pending.assumed && (
											<div className="col-md-12">
												<label className="text-muted small">Assumed record</label>
												<pre
													className="mb-0 p-2 bg-light rounded"
													style={{ fontSize: '0.85rem' }}
												>
													{JSON.stringify(item.pending.assumed, null, 2)}
												</pre>
											</div>
										)}
									</div>
								</div>
							)}

							{item.recent_sms && item.recent_sms.length > 0 && (
								<div className="mb-4">
									<h6 className="border-bottom pb-2 mb-3">
										<i className="bi bi-send me-2" />
										Recent Outbound Alerts (24h)
									</h6>
									<div className="d-flex flex-column gap-3">
										{item.recent_sms.map((sms) => (
											<div
												key={sms.id}
												className="p-3 bg-light rounded border"
											>
												<div className="d-flex justify-content-between align-items-start mb-2 flex-wrap gap-2">
													<div>
														<span className="badge bg-secondary me-2">
															<code>{sms.template_key}</code>
														</span>
														{sms.tier && (
															<span className="badge bg-info me-2">
																{sms.tier}
															</span>
														)}
														<span
															className={`badge ${
																sms.status === 'sent'
																	? 'bg-success'
																	: sms.status === 'sent_digest'
																	? 'bg-info'
																	: sms.status === 'failed'
																	? 'bg-danger'
																	: 'bg-warning'
															}`}
														>
															{sms.status}
														</span>
													</div>
													<div className="text-muted small">
														<i className="bi bi-clock me-1" />
														{formatDate(sms.sent_at)}
													</div>
												</div>

												{sms.property_address && (
													<div className="small text-muted mb-2">
														<i className="bi bi-building me-1" />
														<strong>Property:</strong> {sms.property_address}
													</div>
												)}

												{sms.twilio_sid && (
													<div className="small text-muted mb-2">
														<strong>Twilio SID:</strong>{' '}
														<code>{sms.twilio_sid}</code>
													</div>
												)}

												{sms.body ? (
													<div className="mt-2">
														<label className="text-muted small fw-semibold">
															Outbound Message Body:
														</label>
														<div className="p-2 bg-white rounded border">
															<pre
																className="mb-0 text-dark"
																style={{
																	fontSize: '0.85rem',
																	whiteSpace: 'pre-wrap',
																}}
															>
																{sms.body}
															</pre>
														</div>
													</div>
												) : (
													<div className="small text-muted">
														<em>Message body not available.</em>
													</div>
												)}

												{sms.error_message && (
													<div className="alert alert-danger mb-0 mt-2 py-2">
														<small>
															<strong>Error:</strong> {sms.error_message}
														</small>
													</div>
												)}
											</div>
										))}
									</div>
								</div>
							)}

							{item.error_message && (
								<div className="mb-4">
									<h6 className="border-bottom pb-2 mb-3 text-danger">
										Error
									</h6>
									<div className="alert alert-danger mb-0">
										<code>{item.error_message}</code>
									</div>
								</div>
							)}

							{item.payload && (
								<div className="mb-4">
									<h6 className="border-bottom pb-2 mb-3">Webhook Payload</h6>
									<pre
										className="mb-0 p-3 bg-light rounded"
										style={{ fontSize: '0.85rem' }}
									>
										{JSON.stringify(item.payload, null, 2)}
									</pre>
								</div>
							)}

							<div className="mb-0">
								<h6 className="border-bottom pb-2 mb-3">Technical Details</h6>
								<div className="row g-3">
									<div className="col-md-4">
										<label className="text-muted small">Log ID</label>
										<div>
											<code>#{item.id}</code>
										</div>
									</div>
									<div className="col-md-8">
										<label className="text-muted small">Message SID</label>
										<div>
											<code>{item.message_sid || '—'}</code>
										</div>
									</div>
									<div className="col-md-4">
										<label className="text-muted small">HTTP</label>
										<div>{item.http_status || '—'}</div>
									</div>
									<div className="col-md-4">
										<label className="text-muted small">SMS Status</label>
										<div>{item.sms_status || '—'}</div>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-secondary"
								onClick={onClose}
							>
								Close
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SmsResponseDetailsModal;
